import React from 'react';
import { Box, Typography, Divider, Button, Paper } from '@mui/material';

const TeamInviteEmailsPreview = ({ subject, message, callToAction, showTouchInfo }) => {

    // Function to parse message and replace variables with placeholders
    const getFormattedMessage = (msg) => {
        if (!msg) return "";
        return msg
            .replace(/{firstName}/g, "{Touch Team Member Name}")
            .replace(/{teamName}/g, "{Your Team}")
            .replace(/{inviterName}/g, "{Inviter Name}")
            .split('\n').map((item, key) => {
                return <span key={key}>{item}<br /></span>
            });
    };

    return (
        <Paper elevation={0} sx={{ p: 4, borderRadius: 2, backgroundColor: 'white', height: '100%' }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h5" fontWeight="bold">
                    Email & Pass Login Email Preview
                </Typography>
            </Box>

            {/* Mobile Preview Container */}
            <Box sx={{
                border: '1px solid #e0e0e0',
                borderRadius: '16px',
                maxWidth: '400px', // Mobile width
                margin: '0 auto',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}>
                {/* Header Bar */}
                <Box sx={{ backgroundColor: '#f5f5f5', p: 1.5, borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box sx={{ width: 40, height: 4, backgroundColor: '#d0d0d0', borderRadius: 2 }} />
                </Box>

                {/* Email Header Fields */}
                <Box sx={{ p: 2, borderBottom: '1px solid #f0f0f0' }}>
                    <Box sx={{ display: 'flex', mb: 1 }}>
                        <Typography variant="caption" color="text.secondary" sx={{ width: 50 }}>From:</Typography>
                        <Typography variant="caption" fontWeight="bold">Touch</Typography>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant="caption" color="text.secondary" sx={{ width: 50 }}>Subject:</Typography>
                        <Typography variant="caption" fontWeight="bold">{subject}</Typography>
                    </Box>
                </Box>

                {/* Email Body */}
                <Box sx={{ p: 3 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                        Message:
                    </Typography>

                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: 3, lineHeight: 1.6 }}>
                        {getFormattedMessage(message)}
                    </Typography>

                    {/* Join Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                borderRadius: '24px',
                                textTransform: 'none',
                                px: 4,
                                py: 1,
                                fontWeight: 'bold',
                                boxShadow: 'none'
                            }}
                        >
                            {callToAction}
                        </Button>
                    </Box>

                    {/* Credentials Preview */}
                    <Box sx={{ backgroundColor: '#f9f9f9', p: 2, borderRadius: 1, mb: 3 }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            <strong>Email:</strong> {'{Email}'}
                        </Typography>
                        <Typography variant="body2">
                            <strong>Password:</strong> {'{Password}'}
                        </Typography>
                    </Box>

                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                        Please log in to Touch by February 13, 2026
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    {/* What is Touch? Section (Conditional) */}
                    {showTouchInfo && (
                        <Box>
                            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                                What is Touch?
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.5, display: 'block', mb: 2 }}>
                                Touch is an easy to use mobile app that helps you make the most of your in-person interactions. With the app, you can share your new digital business card, scan paper business cards, scan event badges, manage your contacts, and more.
                            </Typography>
                            <Typography variant="caption" color="primary" sx={{ fontWeight: 'bold', cursor: 'pointer' }}>
                                See Tutorials
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Paper>
    );
};

export default TeamInviteEmailsPreview;
